export default __webpack_public_path__ + "static/media/User.c9d2f48a.svg";